import { createFileRoute } from '@tanstack/react-router';
import StubPage from '@/pages/StubPage.jsx';

function PartiesRoute() {
  return <StubPage name="parties" label="Liquidity Events" />;
}

export const Route = createFileRoute('/parties')({ component: PartiesRoute });
